// extracted by mini-css-extract-plugin
module.exports = {"textMasking":"textMaskingCroppingStyle_textMasking__OZvgL"};